export const BANKING_LANDING_PAGE_NAME = 'category_selling_banking_landing';

export const BANKING_LANDING_OPTION_EVENTS = Object.freeze({
  appPageName: BANKING_LANDING_PAGE_NAME,
  elementNames: {
    mercuryCta: 'get_started_mercury_catbankupsell',
    bankOfAmericaOfferLink: 'view_BoA_offer_page_catbankupsell',
    bankOfAmericaCta: 'contact_me_BoA_catbankupsell',
    mercuryAgreementLink: 'mercury_agreement_catbankupsell'
  }
});
